"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpediteDeliveryCard = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _Order = require("../Order");
var _clsx = _interopRequireDefault(require("clsx"));
var _getPrefixCls = require("../../utils/getPrefixCls");
var _RichText = require("../RichText");
var _Text = require("../Text");
var _reactSvg = require("react-svg");
var _successCircle = _interopRequireDefault(require("../../assets/images/success-circle.svg"));
var _constants = require("../../utils/constants");
var _LocaleProvider = require("../LocaleProvider");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var ExpediteDeliveryCard = function ExpediteDeliveryCard(props) {
  var order = props.order,
    title = props.title,
    keyMessage = props.keyMessage,
    additionalMessage = props.additionalMessage,
    customerElement = props.customerElement,
    previewMockData = props.previewMockData,
    shouldHandleDateVariable = props.shouldHandleDateVariable,
    orderStatusNumber = props.orderStatusNumber;
  var _useLocale = (0, _LocaleProvider.useLocale)(),
    trans = _useLocale.trans;
  var orderStatusText = (order === null || order === void 0 ? void 0 : order.orderStatusText) || '';
  if (orderStatusNumber && orderStatusNumber > 0) {
    orderStatusText = trans(_constants.DEFAULT_ORDER_TYPE_DECS_LIST[orderStatusNumber - 1]);
  }
  var ref = (0, _react.useRef)(null);
  var handleVariableShow = function handleVariableShow() {
    var _ref$current;
    var variableDom = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.querySelectorAll(".".concat(_RichText.STRING_VARIABLE_CONTAINER_CLASS));
    if (variableDom !== null && variableDom !== void 0 && variableDom.length) {
      (0, _RichText.getShowCustomVariable)(variableDom)();
    }
  };
  var handleVariableHide = function handleVariableHide() {
    var _ref$current2;
    var variableDom = (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.querySelectorAll(".".concat(_RichText.STRING_VARIABLE_CONTAINER_CLASS));
    if (variableDom !== null && variableDom !== void 0 && variableDom.length) {
      (0, _RichText.getHideCustomVariable)(variableDom)();
    }
  };
  var richtextProps = {
    previewMockData: previewMockData,
    shouldHandleDateVariable: shouldHandleDateVariable,
    handleVariableShow: handleVariableShow,
    handleVariableHide: handleVariableHide
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('delivery-card'))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('delivery-card-head'))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('delivery-card-head-icon'))
  }, /*#__PURE__*/_react.default.createElement(_reactSvg.ReactSVG, {
    src: _successCircle.default,
    style: {
      borderRadius: '8px'
    }
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('delivery-card-head-title'))
  }, title)), customerElement ? customerElement : /*#__PURE__*/_react.default.createElement("div", null, order && /*#__PURE__*/_react.default.createElement(_Order.Order, _objectSpread(_objectSpread({}, order), {}, {
    orderStatusText: orderStatusText
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('delivery-card-detail')),
    ref: ref
  }, /*#__PURE__*/_react.default.createElement(_Text.Text, (0, _extends2.default)({
    content: keyMessage || '',
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('delivery-card-detail-title'))
  }, richtextProps)), /*#__PURE__*/_react.default.createElement(_Text.Text, (0, _extends2.default)({
    content: additionalMessage || '',
    className: (0, _clsx.default)((0, _getPrefixCls.getPrefixCls)('delivery-card-detail-content'))
  }, richtextProps)))));
};
exports.ExpediteDeliveryCard = ExpediteDeliveryCard;